import { decrypt } from '@/helpers/encryption';
import { STORAGE, useLocalStorageStore } from '@/store';

export const getUserEmail = () => {
  const value = useLocalStorageStore
    .getState()
    .get<string | null>(STORAGE.USER_EMAIL);

  if (value == null) return;

  return decrypt(value);
};

export const obscureEmail = (email?: string) => {
  if (email == null) return;

  try {
    const [name, domain] = email.split('@');
    return name
      .substr(0, 3)
      .concat(Array(name.length - 3).join('*'))
      .concat('@')
      .concat(domain);
  } catch {
    return;
  }
};
